module.exports = __webpack_public_path__ + "media/dante-full-intro.6c3c0640.mp4";